<script setup lang="ts">
import { useI18n } from 'vue-i18n'

interface Props {
  /** The card header text */
  cardHeader: string
  /** The informational text */
  infoText: string
  /** The download link URL */
  link: string
}

defineProps<Props>()

defineOptions({
  name: 'DocumentLinkCard'
})

const { t } = useI18n()
</script>

<template>
  <VCard class="class shadow-card outline-2 outline-secondary-200">
    <VCardText
      class="flex flex-col flex-wrap items-center gap-content md:flex-row"
    >
      <div class="border-secondary-200 md:border-r-2 md:py-3 md:pr-2">
        <VIcon icon="$file-outline" size="x-large" class="text-primary" />
      </div>

      <div class="flex-1 text-center md:text-left">
        <p class="font-semibold">{{ cardHeader }}</p>
        <p>{{ infoText }}</p>
      </div>

      <PrimaryButton
        class="min-w-32"
        :href="link"
        download
        :text="t('general.download')"
      />
    </VCardText>
  </VCard>
</template>
